(function () {
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.size = 4;
        this.score = 0;
        this.status = "idle";
        this.initialState = initialState || this._createEmptyBoard();
        this.board = initialState ? this._cloneBoard(initialState) : this._createEmptyBoard();
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "_cloneBoard",
            value: function _cloneBoard(board) {
                return board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
            }
        },
        {
            key: "_createEmptyBoard",
            value: function _createEmptyBoard() {
                var _this = this;
                return Array.from({
                    length: this.size
                }, function() {
                    return Array(_this.size).fill(0);
                });
            }
        },
        {
            key: "_addRandomTile",
            value: function _addRandomTile() {
                var emptyCells = [];
                for(var row = 0; row < this.size; row++){
                    for(var col = 0; col < this.size; col++)if (this.board[row][col] === 0) emptyCells.push([
                        row,
                        col
                    ]);
                }
                if (emptyCells.length === 0) return;
                var _emptyCells_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[Math.floor(Math.random() * emptyCells.length)], 2), r = _emptyCells_Math_floor[0], c = _emptyCells_Math_floor[1];
                this.board[r][c] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "_moveRowLeft",
            value: function _moveRowLeft(row) {
                var filtered = row.filter(function(value) {
                    return value !== 0;
                });
                for(var i = 0; i < filtered.length - 1; i++)if (filtered[i] === filtered[i + 1]) {
                    filtered[i] *= 2;
                    this.score += filtered[i];
                    filtered[i + 1] = 0;
                }
                var merged = filtered.filter(function(value) {
                    return value !== 0;
                });
                while(merged.length < this.size)merged.push(0);
                return merged;
            }
        },
        {
            key: "_moveLeft",
            value: function _moveLeft() {
                var _this = this;
                var moved = false;
                this.board = this.board.map(function(row) {
                    var newRow = _this._moveRowLeft(row);
                    if (!_this._areRowsEqual(row, newRow)) moved = true;
                    return newRow;
                });
                if (moved) {
                    this._addRandomTile();
                    if (this._checkLose()) this.status = "lose";
                    if (this._checkWin()) this.status = "win";
                }
            }
        },
        {
            key: "_areRowsEqual",
            value: function _areRowsEqual(a, b) {
                return a.every(function(value, index) {
                    return value === b[index];
                });
            }
        },
        {
            key: "_reverseRows",
            value: function _reverseRows(board) {
                return board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                });
            }
        },
        {
            key: "_transpose",
            value: function _transpose(board) {
                return board[0].map(function(_, col) {
                    return board.map(function(row) {
                        return row[col];
                    });
                });
            }
        },
        {
            key: "_checkLose",
            value: function _checkLose() {
                for(var row = 0; row < this.size; row++)for(var col = 0; col < this.size; col++){
                    if (this.board[row][col] === 0) return false;
                }
                for(var row1 = 0; row1 < this.size; row1++)for(var col1 = 0; col1 < this.size - 1; col1++){
                    if (this.board[row1][col1] === this.board[row1][col1 + 1]) return false;
                }
                for(var col2 = 0; col2 < this.size; col2++)for(var row2 = 0; row2 < this.size - 1; row2++){
                    if (this.board[row2][col2] === this.board[row2 + 1][col2]) return false;
                }
                return true;
            }
        },
        {
            key: "_checkWin",
            value: function _checkWin() {
                for(var row = 0; row < this.size; row++)for(var col = 0; col < this.size; col++){
                    if (this.board[row][col] === 2048) return true;
                }
                return false;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                this._moveLeft();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.board = this._reverseRows(this.board);
                this._moveLeft();
                this.board = this._reverseRows(this.board);
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.board = this._transpose(this.board);
                this._moveLeft();
                this.board = this._transpose(this.board);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.board = this._transpose(this.board);
                this.board = this._reverseRows(this.board);
                this._moveLeft();
                this.board = this._reverseRows(this.board);
                this.board = this._transpose(this.board);
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this._cloneBoard(this.board);
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                if (this.status === "playing") return;
                this.score = 0;
                this.status = "playing";
                this.board = this._createEmptyBoard();
                this._addRandomTile();
                this._addRandomTile();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.status = "idle";
                this.start();
            }
        }
    ]);
    return Game;
}();


var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
var $197cd56b15c33885$var$button = document.querySelector("button");
var $197cd56b15c33885$var$cells = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$scoreEl = document.querySelector(".game-score");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
document.body.style.overflow = "hidden";
$197cd56b15c33885$var$button.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$button.classList.replace("start", "restart");
        $197cd56b15c33885$var$button.textContent = "Restart";
        $197cd56b15c33885$var$messageStart.style.display = "none";
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
        $197cd56b15c33885$var$messageWin.classList.add("hidden");
    }
    $197cd56b15c33885$var$renderBoard($197cd56b15c33885$var$game.getState());
    $197cd56b15c33885$var$updateScore($197cd56b15c33885$var$game.getScore());
});
var $197cd56b15c33885$var$keyActions = {
    ArrowLeft: function() {
        return $197cd56b15c33885$var$game.moveLeft();
    },
    ArrowRight: function() {
        return $197cd56b15c33885$var$game.moveRight();
    },
    ArrowUp: function() {
        return $197cd56b15c33885$var$game.moveUp();
    },
    ArrowDown: function() {
        return $197cd56b15c33885$var$game.moveDown();
    }
};
document.addEventListener("keydown", function(events) {
    var action = $197cd56b15c33885$var$keyActions[events.key];
    if (!action) return;
    action();
    $197cd56b15c33885$var$renderBoard($197cd56b15c33885$var$game.getState());
    $197cd56b15c33885$var$updateScore($197cd56b15c33885$var$game.getScore());
    if ($197cd56b15c33885$var$game.getStatus() === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
    if ($197cd56b15c33885$var$game.getStatus() === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
});
function $197cd56b15c33885$var$renderBoard(board) {
    var flatBoard = board.flat();
    $197cd56b15c33885$var$cells.forEach(function(cell, index) {
        var value = flatBoard[index];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value > 0) cell.classList.add("field-cell--".concat(value));
    });
}
function $197cd56b15c33885$var$updateScore(score) {
    $197cd56b15c33885$var$scoreEl.textContent = score;
}

})();
//# sourceMappingURL=index.c18dd7ca.js.map
